import React from 'react';
import { Container, FormWrap, Icon, FormContent, Form, FormH1, FormLabel, FormInput, FormButton, Text } from './SigninElements';

const SignIn = () => {

    const continueButton = (e) => {
        e.preventDefault();
    }

    return (
        <>
            <Container>
                <FormWrap>
                    <Icon to="/">Tech-Phoenix</Icon>
                    <FormContent>
                        <Form action="#">
                            <FormH1>Sign In to Account</FormH1>
                            <FormLabel htmlFor='for'>Email</FormLabel>
                            <FormInput type='email' required />
                            <FormLabel htmlFor='for'>Password</FormLabel>
                            <FormInput type='password' required />
                            <FormButton type='submit' onClick={continueButton} >Continue</FormButton>
                            <Text>Forgot Password</Text>
                        </Form>
                    </FormContent>
                </FormWrap>
            </Container>
        </>
    )
}

export default SignIn
